import { useMemo, useRef, useState } from "react";
import { Box, Divider, Grid } from "@mzc-pdc/ui";
import { StyledListTools } from "./list-tools.styled";
import TreeViewTools from "../tree-view-tools/tree-view-tools";
import { useSelector } from "react-redux";
import { LIST_VIEW_TYPE } from "@constants";
import ListToolCollapse from "src/features/list-tools/list-tool-collapse";
import ListToolViewToggleButton from "@features/list-tools/list-tool-view-toggle-button";
import compareVersions, { VERSION_CM_4721_SHARES } from "@cores/version";

const ListTools = ({
                       domain,
                       sortOptions,
                       getButtons = () => [],
                       getPopperButtons = () => [],
                       pagination,
                       filter,
                       pageCount, //현재 페이지 내 총 항목 갯수
                       numSelected,
                       onChangeNumSelected,
                       totalView = false,
                       totalCount = 0,
                       isCardView,
                       onToggleViewType,
                       treeViewProps,
                       onChangeSort,
                       onChangeSortAsc,
                       hideCheckbox = false,
                       collapseMode,
                       hiddenDivider
                   }) => {
    const {
        activeView,
        hierarchyType,
        viewSelectButton,
        breadcrumbMenu,
        onClickFolderTree,
        onClickTreeItem,
        onToggleModal,
    } = treeViewProps ?? {};
    const listToolRef = useRef(null);
    const [toolSize, setToolSize] = useState(null);
    const stage = useSelector(({ stage }) => stage);

    const handleClearCheckAll = () => {
        onChangeNumSelected(false);
    };

    const handleChangeCheckAll = () => {
        if (!pageCount || (pageCount?.length === 0 && numSelected?.length === 0)) return;
        onChangeNumSelected(pageCount !== numSelected);
    };

    const isCollapsed = useMemo(() => numSelected > 0, [numSelected]);

    //Note: TreeView를 사용하는 경우와 하지 않는 경우 아래 버튼의 위치가 달라져야한다.
    const viewToggleButtons = useMemo(() => {
        if (!onToggleViewType) return undefined;
        return (
            <>
                <Divider flexItem orientation={"vertical"} sx={{ my: 0.75, mx: 1.25 }} />
                <ListToolViewToggleButton isCardView={isCardView} onChange={onToggleViewType} />
            </>
        );
    }, [isCardView, onToggleViewType]);

    return (
        <StyledListTools id={"list-tools"} ref={listToolRef}>
            {treeViewProps && (
                <Box>
                    <Grid container alignItems={"center"} justifyContent={"flex-end"} py={1.5} gap={1.5}>
                        {activeView?.toLowerCase() !== LIST_VIEW_TYPE.HIERARCHY && <Grid item>{viewSelectButton}</Grid>}
                        <Grid item xs>
                            {activeView?.toLowerCase() === LIST_VIEW_TYPE.HIERARCHY && (
                                <TreeViewTools
                                    domain={domain}
                                    hierarchyType={hierarchyType}
                                    breadcrumbMenu={breadcrumbMenu}
                                    onClickFolderTree={onClickFolderTree}
                                    onClickTreeItem={onClickTreeItem}
                                    onToggleModal={onToggleModal}
                                />
                            )}
                        </Grid>
                        {onToggleViewType && viewToggleButtons}
                    </Grid>
                </Box>
            )}

            <ListToolCollapse
                mode={collapseMode}
                type={domain}
                sortOptions={sortOptions}
                isCollapsed={isCollapsed}
                handleClearCheckAll={handleClearCheckAll}
                handleChangeCheckAll={onChangeNumSelected ? handleChangeCheckAll : undefined}
                toolSize={toolSize}
                numSelected={numSelected}
                pageCount={pageCount}
                getButtons={getButtons}
                getPopperButtons={getPopperButtons}
                pagination={pagination}
                filter={filter}
                hideCheckbox={hideCheckbox || compareVersions(stage.version, VERSION_CM_4721_SHARES) < 0}
                viewToggleButtons={treeViewProps ? undefined : viewToggleButtons}
                totalCount={totalCount}
                totalView={totalView}
                onChangeSort={onChangeSort}
                onChangeSortAsc={onChangeSortAsc}
                hiddenDivider={hiddenDivider}
            />
        </StyledListTools>
    );
};

export default ListTools;
